export const useCoachingStatsTime = (libraryBookId?: string) => {
  const timeForInactivity = 30 * 1000;
  const delayIncInSeconds = 10;
  const delayIncInMilliseconds = delayIncInSeconds * 1000; // 10 seconds

  const coachingStatsStore = useCoachingStatsStore();

  const { idle } = useIdle(timeForInactivity);

  const { pause, resume } = useIntervalFn(() => {
    if (idle.value) return;
    if (!libraryBookId) return;
    coachingStatsStore.incTime(libraryBookId, delayIncInSeconds);
  }, delayIncInMilliseconds);

  watch(
    () => idle.value,
    (isIdle) => {
      if (isIdle) {
        pause();
      } else {
        resume();
      }
    }
  );
};
